import { Component, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleCurrentInfo } from 'src/app/_shared/models/vehicle';
import { RbUiComponentsModule } from '@inst-iot/bosch-angular-ui-components';
import { createPlotlyChart } from 'src/app/_shared/plotlyConfig';
import { TransformXAxisPipe } from 'src/app/_shared/pipes/transform-xaxis.pipe';

@Component({
  selector: 'app-soc-events-low-ef-chart',
  standalone: true,
  imports: [CommonModule, RbUiComponentsModule],
  templateUrl: './soc-events-low-ef-chart.component.html',
  styleUrls: ['./soc-events-low-ef-chart.component.scss']
})
export class SocEventsLowEfChartComponent {
  currentVehicleData: any;
  @Input() selectedVehicles: any[] = [];
  @Input() dataLoadingSocEvents: boolean = false;
  @Input() errorMessageSocEvents: boolean = false;
  @Input() stateOfChargeEventsDatapoints: any = {};
  @Input() vehiclesChargingInsightsDataPoint: any = {};
  @Input() fleetId: string[] = [];
  vehiclesInfo!: { [key: string]: VehicleCurrentInfo; };
  chartRange!: { range: [number, number] };

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataLoadingSocEvents = true;
    this.errorMessageSocEvents = false;
    if (Object.keys(this.stateOfChargeEventsDatapoints).length !== 0 && Object.keys(this.vehiclesChargingInsightsDataPoint).length !== 0) {
      const fleetData = this.plotFleetSocEventsLow();
      this.fetchVehicleInfoAndUpdateChart(fleetData);
    } else {
      this.dataLoadingSocEvents =   false;
      this.errorMessageSocEvents = true;
    }
  }

  fetchVehicleInfoAndUpdateChart(fleetData: any[]): void {
    const deviceSerialNumber: string[] = this.selectedVehicles.map(vehicle => vehicle.batteryIdentifier);
    const vehicleNameMap: { [key: string]: string } = {};

    this.selectedVehicles.forEach(vehicle => {
      vehicleNameMap[vehicle.batteryIdentifier] = vehicle.name;
    });

    const fleetHasData = fleetData.some(fd => Array.isArray(fd.y) && fd.y.length > 0);

    let vehicleHasData = false;
    const averageLines = deviceSerialNumber.map((id, index) => {
      const evLowSoc = this.vehiclesChargingInsightsDataPoint[id]?.lowSocEvents;
      const vehicleName = vehicleNameMap[id];

      if (evLowSoc !== null && evLowSoc !== undefined) {
        vehicleHasData = true;
      }

      const maxPercentAmount = Math.max(...fleetData.flatMap(plot => plot.y));

      return {
        x: [evLowSoc, evLowSoc],
        y: [0, maxPercentAmount],
        type: 'scatter',
        mode: 'lines',
        name: vehicleName,
        line: {
          color: this.getVehicleColor(index),
          width: 8 
        }
      };
    });

    if (!fleetHasData && !vehicleHasData) {
      this.errorMessageSocEvents = true;
      this.dataLoadingSocEvents = false;
      return;
    } else {
      this.errorMessageSocEvents = false;
    }

    const combinedPlotData = [...fleetData, ...averageLines];
    this.updateChart(combinedPlotData);
    this.dataLoadingSocEvents = false;

  }

  getVehicleColor(index: number): string {
    const colors = ['#007BC0', '#18837E','#9E2896'];
    return colors[index % 3];
  }

  plotFleetSocEventsLow(): any[] {
    const transformXAxisPipe = new TransformXAxisPipe();
    return Object.keys(this.stateOfChargeEventsDatapoints).flatMap((fleetId: string) => {
      const plotData = this.stateOfChargeEventsDatapoints[fleetId]
      const filteredData = plotData.filter((dataObject: any) => dataObject.lowSocEvents !== null);
      const highSoc = filteredData.map((dataObject: any) => dataObject.binSocEvents);
      const percentAmount = filteredData.map((dataObject: any) => dataObject.lowSocEvents);
      this.chartRange = transformXAxisPipe.transform(highSoc, percentAmount, 3,100);

      return {
        x: highSoc,
        y: percentAmount,
        type: 'bar',
        name: `Fleet`,
        marker: {
          color: '#8A9097'
        }
      };
    });
  }

  updateChart(data: any[]): void {
    const layout = {
      title: 'Low State of Charge Events',
      font: {
        family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
        size: 13,
      },
      barmode: 'group',
      xaxis: {
        title: 'Number of low State of Charge events',
        range: this.chartRange?.range
      },
      yaxis: {
        title: 'Percentage of Fleet Vehicles [%]'
      },
      legend: {
        orientation: 'h',
        y: -0.3,
        xanchor: 'center',
        x: 0.5,
        font: {
          family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
          size: 13,
        },
      }
    };

    createPlotlyChart('soc-events-low-ef-chart', data, layout);
  }

}
